import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { navSliceActions } from "../../store/slices/NavSlice";
import { useStoreDispatch } from "../../store/Hooks";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InteractionScheduleReport from "./InteractionScheduleReport";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';

interface InteractionScheduleProps {
    anchorID: number;
    subjectID?: number | undefined;
    targetID?: number | undefined
}

const InteractionSchedule = (props: InteractionScheduleProps) => {
    const dispatch = useStoreDispatch();

    return (
        <Box sx={{ padding: "10px", width: "1000px" }}>
            <div
                style={{
                    height: "30px",
                    paddingTop: "20px",
                    paddingBottom: "30px",
                    paddingRight: "15px",
                    paddingLeft: "15px",
                    color: "white",
                    backgroundColor: "#11508E",
                    fontWeight: "bold",
                }}
            >
                <div style={{ float: "right", color: "white" }}>
                    <Tooltip title={"Exit Without Saving"}>
                        <IconButton
                            onClick={() => {
                                dispatch(
                                    navSliceActions.closeRightDrawer({}),
                                );
                            }}
                            color="inherit"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Tooltip>
                </div>
                <div style={{ fontSize: "1.5em" }}>Anchor Schedule</div>

            </div>
            <InteractionScheduleReport anchorID={props.anchorID} headers={[]} rows={[]} title={"Interaction Schedule"} />
            <InteractionScheduleReport subjectID={props.subjectID} anchorID={props.anchorID} headers={[]} rows={[]} title={"Contact Log"} omittedFields={['all_comms']} />
            <InteractionScheduleReport anchorID={props.anchorID} headers={[]} rows={[]} title={"Interaction Communication Readable"} />
            <InteractionScheduleReport anchorID={props.anchorID} headers={[]} rows={[]} title={"Possible Contacts"} />
            <br />
            <Button
                onClick={() => {
                    dispatch(
                        navSliceActions.closeRightDrawer({}),
                    );
                }}
                color="warning"
                style={{ marginLeft: "10px" }}
                variant="contained"
            >
                <ArrowBackIcon />
                Exit
            </Button>
        </Box>
    )
}


export default InteractionSchedule